var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0071f2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.425,5.01a2.571,2.571,0,0,0-1.824.752L6.444,13.919a1.29,1.29,0,0,0-.328.559L5.022,18.306a.553.553,0,0,0,.683.683L9.535,17.9h0a1.292,1.292,0,0,0,.557-.328L18.249,9.41a2.576,2.576,0,0,0-1.824-4.4Zm0,1.1a1.468,1.468,0,0,1,1.042.435h0a1.465,1.465,0,0,1,0,2.084l-.715.715L14.668,7.258l.715-.715A1.469,1.469,0,0,1,16.425,6.109ZM13.886,8.04l2.085,2.085L9.31,16.785a.187.187,0,0,1-.08.047l-2.872.821.821-2.873h0a.18.18,0,0,1,.047-.079Z",
    transform: "translate(-5.001 -5.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f326be370436d48234493a564f803c36.svg";
export { ForwardRef as ReactComponent };